var _linearGradient, _linearGradient2, _path, _linearGradient3, _path2, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _path6, _linearGradient6, _path7, _linearGradient7, _path8, _linearGradient8, _path9, _path10, _path11, _linearGradient9, _circle, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0",
    gradientUnits: "userSpaceOnUse",
    x1: -6210.286,
    y1: -3.277,
    x2: -6209.286,
    y2: -3.277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0",
    gradientUnits: "userSpaceOnUse",
    x1: -6210.286,
    y1: -3.277,
    x2: -6209.286,
    y2: -3.277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M144.481 107.257c-1.544 10.166-10.322 17.957-20.92 17.957H57.902a4.664 4.664 0 01-4.664-4.664V65.42a5.785 5.785 0 015.785-5.785H90.95M139.157 68.503a24.273 24.273 0 015.565 15.501"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0",
    gradientUnits: "userSpaceOnUse",
    x1: 683.578,
    y1: 1978.933,
    x2: 758.227,
    y2: 1978.933,
    gradientTransform: "rotate(-22.099 -4519.976 2536.802)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.336 66.026l-8.093-19.705a5.874 5.874 0 013.234-7.654l55.962-22.721a5.874 5.874 0 017.654 3.234l12.648 31.151a5.874 5.874 0 01-3.234 7.654l-31.688 12.764",
    fill: "none",
    stroke: "url(#SVGID_2_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M106.239 48.118l-7.718 3.134a2.812 2.812 0 01-3.663-1.547l-1.004-2.472a2.812 2.812 0 011.547-3.663l7.718-3.134a2.812 2.812 0 013.663 1.547l1.004 2.472a2.813 2.813 0 01-1.547 3.663z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0",
    gradientUnits: "userSpaceOnUse",
    x1: 690.7,
    y1: 1978.957,
    x2: 703.819,
    y2: 1978.957,
    gradientTransform: "rotate(-22.099 -4519.976 2536.802)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M99.175 59.24l9.839-3.995"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0",
    gradientUnits: "userSpaceOnUse",
    x1: 690.421,
    y1: 1986.488,
    x2: 713.815,
    y2: 1986.488,
    gradientTransform: "rotate(-22.099 -4519.976 2536.802)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M101.75 66.323l19.359-7.86"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M138.107 58.987l19.36-7.86"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0",
    gradientUnits: "userSpaceOnUse",
    x1: 706.354,
    y1: 1978.957,
    x2: 719.473,
    y2: 1978.957,
    gradientTransform: "rotate(-22.099 -4519.976 2536.802)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M113.679 53.351l9.839-3.995"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0",
    gradientUnits: "userSpaceOnUse",
    x1: 721.83,
    y1: 1978.957,
    x2: 734.949,
    y2: 1978.957,
    gradientTransform: "rotate(-22.099 -4519.976 2536.802)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M128.018 47.529l9.839-3.994"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0",
    gradientUnits: "userSpaceOnUse",
    x1: 737.484,
    y1: 1978.957,
    x2: 750.603,
    y2: 1978.957,
    gradientTransform: "rotate(-22.099 -4519.976 2536.802)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M142.522 41.641l9.839-3.995"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M136.865 107.335c-.601 10.028-8.923 17.975-19.102 17.975H57.397a4.218 4.218 0 01-4.218-4.218V66.705h64.584c10.156 0 18.465 7.912 19.098 17.908"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M149.217 106.612h-25.202c-6.013 0-10.887-4.874-10.887-10.887 0-6.013 4.874-10.887 10.887-10.887h25.202c.866 0 1.567.702 1.567 1.567v18.639c0 .866-.701 1.568-1.567 1.568z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0",
    gradientUnits: "userSpaceOnUse",
    x1: 119.476,
    y1: 95.821,
    x2: 129.033,
    y2: 95.821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124.255,
    cy: 95.821,
    r: 3.529,
    fill: "none",
    stroke: "url(#SVGID_8_5bb6abca34c2b8a1a040f141fa13dd3895d2d443dc49e51829042bf1ebeb23d0)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M71.132 72.432v4.769M71.132 83.204v4.769M71.132 93.813v4.769M71.132 104.585v4.769M71.132 115.031v4.77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionPayments);
export default __webpack_public_path__ + "static/media/subscriptionPayments.2b07b23eceb110b371ec12c0f4055170.svg";
export { ForwardRef as ReactComponent };